"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationMobileComponent = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_router_dom_1 = require("react-router-dom");
const NavBarHome_1 = require("../../../components/mobile-view/nav-bar/NavBarHome");
const NavBarMobile_1 = require("../../../components/mobile-view/nav-bar/NavBarMobile");
const NavigationMobileComponent = () => {
    const location = (0, react_router_dom_1.useLocation)();
    const currentPath = location.pathname;
    return currentPath === '/' ? (0, jsx_runtime_1.jsx)(NavBarHome_1.NavBarHome, {}) : (0, jsx_runtime_1.jsx)(NavBarMobile_1.NavBarMobile, {});
};
exports.NavigationMobileComponent = NavigationMobileComponent;
